import type { ProgressInfo } from '@thinkalpha/table-client';

/**
 * The table construction state presented by the UI.
 *
 * `pending` deliberately has no numeric value: the percentage is not meaningful
 * until the table server has processed the initial key set.
 */
export type TableConstructionProgress = 'pending' | number | undefined;

export function getTableConstructionProgress(
    update: Pick<ProgressInfo, 'initialKeysetProcessed' | 'percentage'>,
    enhancedProgressEnabled: boolean,
): TableConstructionProgress {
    return enhancedProgressEnabled && !update.initialKeysetProcessed ? 'pending' : update.percentage;
}

/**
 * The rounded percentage from table-client is the presentation boundary. A
 * rounded 100% intentionally ends the progress treatment even if a small tail
 * of requested cells remains unbound.
 */
export function isTableConstructionActive(progress: TableConstructionProgress): boolean {
    return progress === 'pending' || (typeof progress === 'number' && progress < 100);
}
